import * as React from 'react';
import { Box, styled } from '@mui/system';
import OTP from './otp';

const  OTPInput = () => {
  const [otp, setOtp] = React.useState('');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <OTP separator={<span>-</span>} value={otp} onChange={setOtp} length={6} />
    </Box>
  );
}

export default OTPInput;